import * as React from 'react'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

export function PackagesSubmittedFiltersProvider({children}) {
    const { state, updateState, replaceState, resetState, isModified } = useAppContextState({})

    return <Context.Provider value={{state, updateState, replaceState, resetState, isModified}}>
        {children}
    </Context.Provider>
}

export default Context